import RoutineRecordApi from '~/common/api/zeiterfassungServerApi/RoutineRecordApi';
import { RoutineRecordsWithPictures } from './RoutineRecordsWithPictures';
import { Heading } from '~/common/components/defaultUIComponents';
import useTranslate from '~/common/utils/translate';
import { Badge, Box } from '@chakra-ui/react';

export const RoutineRecords = () => {
  const t = useTranslate();
  const { data: recordCount } =
    RoutineRecordApi.hooks.useRoutinesWithPicturesCount();
  return (
    <Box>
      <Heading mb={5}>
        {t('dashboard.routinePictures')}
        <Badge
          marginLeft={5}
          variant="outline"
          colorScheme="green"
          fontSize={25}
        >
          {recordCount}
        </Badge>
      </Heading>
      <RoutineRecordsWithPictures />
    </Box>
  );
};
